export enum EstadoCivil {
  SOLTEIRO = 'SOLTEIRO',
  CASADO = 'CASADO',
  UNIAO_ESTAVEL = 'UNIAO_ESTAVEL',
  SEPARADO = 'SEPARADO',
  DIVORCIADO = 'DIVORCIADO',
  VIUVO = 'VIUVO',
}
